import React, { Component } from "react";
import Slider from "react-slick";
import $ from "jquery";
import { LazyLoadImage } from "react-lazy-load-image-component";

import "../styles/components/PhotoGallery.css";

export class PhotoGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSlide: 0,
      paddingRight: 0
    };
    this.doResize = null;
  }

  resizeDocument = () => {
    clearTimeout(this.doResize);
    this.doResize = setTimeout(() => {
      const element = $("#hero-element");
      if (element !== null && element !== undefined) {
        const offset = element.offset();
        if (offset) {
          const rightWidthElement = offset.left;
          this.setState({
            paddingRight: rightWidthElement
          });
        }
      }
    }, 100);
  };

  componentDidMount() {
    window.addEventListener("resize", this.resizeDocument);
    this.resizeDocument();
  }

  render() {
    if (this.props.photoList && this.props.photoList.length > 0) {
      var settings = {
        customPaging: i => {
          return (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a>
              <LazyLoadImage
                src={this.props.photoList[i].sizes.medium}
                alt=""
              />
            </a>
          );
        },
        dots: true,
        dotsClass: "slick-thumb",
        infinite: true,
        arrows: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };
    }

    return (
      <div style={{ paddingRight: this.state.paddingRight }}>
        {this.props.photoList ? (
          this.props.photoList.length > 0 && (
            <Slider {...settings}>
              {this.props.photoList.map((item, idx) => {
                return (
                  <div key={idx}>
                    <LazyLoadImage src={item.url} alt={item.name} />
                  </div>
                );
              })}
            </Slider>
          )
        ) : (
          <span>UPS... Brak zdjęć.</span>
        )}
      </div>
    );
  }
}

export default PhotoGallery;
